import { useModal } from '@/common/components/modal-provider/hooks/useModal';
import { InviteUserDialogContent } from './InviteUserDialog';

export function useInviteUserDialog() {
  const showModal = useModal();
  return (supplyPointId: number) =>
    showModal<void>({
      content: ({ resolve }) => (
        <InviteUserDialogContent supplyPointId={supplyPointId} resolve={resolve} />
      ),
    });
}
